"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.759 16.95q-.345.05-.7.05H7a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6.1q0 .357-.05.7c-.313 2.146-2.04 3.844-4.191 4.15M14.6 11.4V6A1.6 1.6 0 0 0 13 4.4H7A1.6 1.6 0 0 0 5.4 6v8A1.6 1.6 0 0 0 7 15.6h3.359v-1.5a2.7 2.7 0 0 1 2.7-2.7zm-2.841 4.13V14.1a1.3 1.3 0 0 1 1.3-1.3h1.469a3.55 3.55 0 0 1-2.77 2.73",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.277 8.643a.7.7 0 0 1-.99.025l-.591-.562v2.568a.7.7 0 0 1-1.4 0V8.106l-.592.562a.7.7 0 1 1-.965-1.014l1.774-1.687a.7.7 0 0 1 .965 0l1.774 1.687a.7.7 0 0 1 .025.99",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=PublishSheetIcon20.js.map